import { render, staticRenderFns } from "./MedisBases.vue?vue&type=template&id=1e34ac3d&"
import script from "./MedisBases.vue?vue&type=script&lang=ts&"
export * from "./MedisBases.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports